import React, { useContext } from "react";
import { Accordion, VideoJS } from "../../components";
import {
  Footer,
  MenuBar,
} from "../../layout/welcome";
import moment from "moment";
import useScrollBarPosition from "../../effect/Scroll";
import { useWindowSize } from "../../effect/WindowSize";
import { authGetRequest, getCourseItemAPI, getRequest } from "../../api/laravel/public/api";
import { MembershipContext } from "../../context/membership/membership";
import { AuthContext } from "../../context/auth/ApiContext";
import { errorMessage } from "../../utils/notification";
import { toast } from "react-toastify";
import { CircularProgress } from "@mui/material";
import { settingContext } from "../../context/Setting/Setting";
import ReadMore from "../../components/ReadMore/ReadMore";
import { useHistory, useParams } from "react-router-dom";
import { useQuery } from "../../utils/query-parameter";
import { _retrieveData, _storeData } from "../../utils/local-storage";
import { Link } from "react-router-dom";
import { VerifiedUser } from "@mui/icons-material";


const CoursePage = () => {
  const [scrollY] = useScrollBarPosition();
  const size = useWindowSize();
  const router = useHistory();
  const param = useQuery();
  const { course } = useParams();
  // const { data } = getCourseItemAPI(course);
  const { membership } = useContext(MembershipContext);
  const [user, setUser] = React.useState({});
  // const { user } = useContext(AuthContext);
  const [data, setData] = React.useState({});
  const [isLoading, setLoading] = React.useState(false);
  const [isPageLoader, setPageLoader] = React.useState(false);
  const [tab, setTab] = React.useState(0);
  // const { page, loading } = React.useContext(settingContext);
  const [page, setPage] = React.useState(null);
  const [loading, setLoadingn] = React.useState(false);
  const [modal, setModal] = React.useState(false);
  const playerRef = React.useRef(null);
  const [session, setSession] = React.useState(0);

  React.useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  React.useEffect(() => {
    checkUser();
  }, []);

  React.useEffect(() => {
    initialApi();
  }, []);

  const handlePlayerReady = (player) => {
    playerRef.current = player;

    // You can handle player events here, for example:
    player.on("waiting", () => {
      console.log("player is waiting");
    });

    player.on("dispose", () => {
      console.log("player will dispose");
    });
  };

  const initialApi = async () => {
    setLoadingn(true);
    const pageData = await _retrieveData("page_data");
    if (pageData) {
      setPage(pageData);
      setLoadingn(true);
    }
    const { data_r, message, isError, isLoading } = await getRequest(
      `/auth/api/page`
    );
    setPage(data_r);
    setLoadingn(false);
    await _storeData(data_r, "page_data");
  };

  const checkUser = async () => {
    let storeUser = await _retrieveData('user');
    if (storeUser) {
      setUser(storeUser);
    }
    const { data_r, isLoading, isError } = await authGetRequest("/account/profile");
    if (isError) {
      setUser({});
      // history.push("/auth/login");
    }
    else {
      await _storeData(data_r, 'user');
      setUser(data_r);
    }
  }

  React.useEffect(() => {
    getCourse();
  }, [course]);

  const getCourse = async () => {
    setPageLoader(true);
    const { data_r, message, isLoading, isError } = await authGetRequest(
      !user ? "/course/view/" + course : "/course/course/view/" + course
    );
    setData(data_r);
    setPageLoader(false);
  };

  const routeCourse = () => {
    let url = null;
    if (!user?.id) {
      url = "/auth/login?dir=course&course=" + course;
      router.push(url);
    } else if (!membership) {
      url = "/student/membership/?dir=course&course=" + course;
      router.push(url);
    } else if (user?.id && data?.enroll) {
      url = "/student/home";
      router.push(url);
    } else if (user?.id && !data?.enroll) {
      enrollCourse();
    }
  };

  const enrollCourse = async () => {
    setLoading(true);

    const { data_r, message, isLoading, isError } = await authGetRequest(
      "/account/course/enroll/" + course
    );
    if (isError) {
      errorMessage(toast, data_r?.message);
      if (data_r?.message.search("expired")) {
        let url = "/student/membership";
        router.push(url);
      }
      setLoading(false);
      return false;
    }
    setLoading(false);
    window.open(data?.google_form, '_blank');
    let url = "/student/home";
    router.push(url);
  };

  return (
    <div id="page-top" class="home">
      <div id="page-wrap">
        <MenuBar menuIndex="auth" setting={page?.setting} loader={isPageLoader} />
        <section className="sub-banner sub-banner-course">
          <div className="awe-static bg-sub-banner-course" style={{ backgroundImage: 'url(../img/course_banner.jpeg)' }} />
          <div className="awe-overlay" />
          <div className="container">
            <div className="sub-banner-content">
              <h1 className="text-center text-white font-bold text-5xl">{data?.title}</h1>
            </div>
          </div>
        </section>
        <section className="course-top">
          <div className="container">
            <div className="row">
              <div className="col-md-5">
                <div className="sidebar-course-intro">
                  <div className="breadcrumb">
                    <Link to="/student/home">Home</Link> /
                    <Link to="/student/courses">Course</Link> /
                    {data?.title}
                  </div>
                  <div className="video-course-intro">
                    <div className="inner">
                      <div className="d-flex flex-column align-items-center justify-content-center">
                        <div className="w-100">
                          {data?.intro_video?.path &&
                            <VideoJS
                              options={{
                                autoplay: false,
                                controls: true,
                                responsive: true,
                                fluid: true,
                                skipForward: true,
                                'playbackRates': [0.7, 1.0, 1.5, 2.0],
                                sources: [
                                  {
                                    src: data?.intro_video?.path,
                                    type: "video/mp4",
                                  },
                                ],
                              }}
                              onReady={handlePlayerReady}
                            />}
                        </div>
                      </div>
                    </div>
                    <div className="flex justify-between">
                      <div className="price">
                        Free
                      </div>
                      <a disabled={isLoading}
                        onClick={routeCourse}
                        className="take-this-course coursor-pointer mc-btn btn-style-1">
                        {!isLoading && (
                          <>
                            <VerifiedUser
                              sx={{ fontSize: 16, marginRight: 2 }}
                              fontSize="large"
                            />
                            {!user?.id && <span>Login and Enroll</span>}
                            {user?.id && data?.enroll && (
                              <span>Continue Learning</span>
                            )}
                            {user?.id && !data?.enroll && <span>Enroll Now</span>}
                          </>
                        )}
                        {isLoading && (
                          <div className="d-flex flex-row align-items-center">
                            <CircularProgress
                              size={15}
                              sx={{ color: "white", marginRight: 2 }}
                            />
                            <p>Connecting</p>
                          </div>
                        )}
                      </a>
                    </div>
                  </div>
                  <div className="new-course">
                    <div className="item course-code">
                      <i className="icon mdi1x mdi mdi-barcode" />
                      <h4><a href="#">Course Code</a></h4>
                      <p className="detail-course"># {data?.uuid}</p>
                    </div>
                    <div className="item course-code">
                      <i className="icon mdi1x mdi mdi-clock" />
                      <h4><a href="#">Duration</a></h4>
                      <p className="detail-course">{data?.estimate_time}</p>
                    </div>
                    <div className="item course-code">
                      <i className="icon mdi1x mdi mdi-calendar-clock" />
                      <h4><a href="#">Open Date</a></h4>
                      <p className="detail-course">{moment(data?.start_date).format('LL')}</p>
                    </div>
                  </div>
                  <hr className="line" />
                  <div className="about-instructor">
                    <h4 className="xsm black bold">About Instructor</h4>
                    <ul>
                      {data?.assign_to?.map((item, index) => (
                        <li>
                          <div className="image-instructor text-center">
                            <img src={process.env.REACT_APP_LOCAL_FILE_PATH +
                              "profile/medium/" +
                              item?.user_detail?.image} alt="" />
                          </div>
                          <div className="info-instructor">
                            <cite className="sm black"><Link to={'/instructor/detail/' + item?.user_detail?.id}>{item?.user_detail?.first_name} {item?.user_detail?.last_name}</Link></cite>
                            {item?.user_detail?.linkedin && <a target="_blank" href={item?.user_detail?.linkedin}><i className="icon mdi1x mdi mdi-linkedin" /></a>}
                            {item?.user_detail?.instagram && <a target="_blank" href={item?.user_detail?.instagram}><i className="icon mdi1x mdi mdi-instagram" /></a>}
                            {item?.user_detail?.twitter && <a target="_blank" href={item?.user_detail?.twitter}><i className="icon mdi1x mdi mdi-twitter" /></a>}
                            <p>
                              <dd
                                dangerouslySetInnerHTML={{
                                  __html: item?.user_detail?.description?.substr(0, 200)?.substr(0, Math.min(200, item?.user_detail?.description?.substr(0, 200).lastIndexOf(" "))) + '.....',
                                }}
                              ></dd>
                            </p>
                            <Link to={'/instructor/detail/' + item?.user_detail?.id}>Read More</Link>
                          </div>
                        </li>
                      ))}
                    </ul>
                  </div>
                  <hr className="line" />
                  <div className="widget widget_equipment">
                    <i className="icon mdi1x mdi mdi-translate" />
                    <h4 className="xsm black bold">Language</h4>
                    <div className="equipment-body">
                      <span>{data?.langauge ? data?.langauge : "English"}</span>
                    </div>
                  </div>
                  <div className="widget widget_tags">
                    <i className="icon mdi1x mdi mdi-note" />
                    <h4 className="xsm black bold">Sections</h4>
                    <div className="tagCould">
                      <span>{data?.section_count}</span>
                    </div>
                  </div>
                  {/* <div className="widget widget_share">
                    <i className="icon mdi1x mdi mdi-share" />
                    <h4 className="xsm black bold">Share course</h4>
                    <div className="share-body">
                      <a href="#" className="twitter" title="twitter">
                        <i className="icon mdi1x mdi mdi-twitter" />
                      </a>
                      <a href="#" className="instagram" title="instagram">
                        <i className="icon mdi1x mdi mdi-instagram" />
                      </a>
                      <a href="#" className="facebook" title="facebook">
                        <i className="icon mdi1x mdi mdi-facebook" />
                      </a>
                      <a href="#" className="whatsapp" title="whatsapp">
                        <i className="icon mdi1x mdi mdi-whatsapp" />
                      </a>
                    </div>
                  </div> */}
                </div>
              </div>
              <div className="col-md-7">
                <div className="tabs-page">
                  <ul className="nav-tabs" role="tablist">
                    <li className="active"><a href="#introduction" role="tab" data-toggle="tab">Introduction</a></li>
                    <li><a href="#outline" role="tab" data-toggle="tab">Outline</a></li>
                    {/* <li><a href="#review" role="tab" data-toggle="tab">Review</a></li>
                    <li><a href="#student" role="tab" data-toggle="tab">Student</a></li>
                    <li><a href="#conment" role="tab" data-toggle="tab">Conment</a></li> */}
                  </ul>
                  {/* Tab panes */}
                  <div className="tab-content">

                    <div className="tab-pane fade in active" id="introduction">
                      <div dangerouslySetInnerHTML={{
                        __html: data?.content,
                      }}>

                      </div>
                    </div>
                    <div className="tab-pane fade" id="outline">
                      {/* SECTION OUTLINE */}
                      {data?.course_section?.map((item, index) => (
                        <Accordion
                          type="test"
                          key={index}
                          id={item.id}
                          item={item}
                          tab={tab}
                          initial={data?.course_section[0]?.id}
                          content={item?.section_item}
                          title={item.title}
                        />
                      ))}
                      {/* END / SECTION OUTLINE */}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <Footer setting={page?.setting} />
      </div>
    </div>
  );
};

export default CoursePage;
